import React from 'react';
import PropTypes from 'prop-types';

import {oeInterfaceManager} from './oe-interface';
import OEInterfaceAdapter from './oe-interface-adapter';
import {OEFeatureAccessTypes, OELicensingEdition} from '../react-oe/oe-types';
import OEToolbox from '../lib/tools/oe-toolbox';
import OELicensingAccessTool from './oe-licensing-access-tool';

export default class OELicensingAccessProvider extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.licensingAccess = this.getLicensingAccess();

        this.onLicensingProductActivationChanged = this.onLicensingProductActivationChanged.bind(this);
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.licensingProductActivationChanged, this.onLicensingProductActivationChanged);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.licensingProductActivationChanged, this.onLicensingProductActivationChanged);
    }

    componentDidMount()    {
        this.onLicensingAccessChanged();
    }

    getLicensingAccess(released) {
        return OELicensingAccessTool.getLicensingAccess(this.oe, released);
    }

    updateLicensingAccess(released) {
        let licensingAccess = this.getLicensingAccess(released);
        if(OEToolbox.shallowEqual(this.licensingAccess, licensingAccess))   return;
        this.licensingAccess = licensingAccess;
        this.onLicensingAccessChanged();
    }

    updateLanguage()   {
        this.updateTargetTypeStrings();
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            if(this.props.omitUpdateOnRelease)  return;
            this.updateLicensingAccess(released);
            return;
        }
        
        this.updateLicensingAccess();
    }

    onLicensingAccessChanged()   {
        if(this.props.onLicensingAccess)    this.props.onLicensingAccess(Object.assign({}, this.licensingAccess), this.oe);
    }

    onLicensingProductActivationChanged()   {
        this.updateLicensingAccess();
    }

    render()    {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
            </React.Fragment>
        );
    }
}

OELicensingAccessProvider.defaultProps = {
    moduleId: '',
    omitUpdateOnRelease: false
};

OELicensingAccessProvider.propTypes = {
    moduleId: PropTypes.string,
    omitUpdateOnRelease: PropTypes.bool,
    onLicensingAccess: PropTypes.func
};

OELicensingAccessProvider.defaultLicensingAccess = function()   {
    let isConnected = false;
    let isLicensing = config.accessType == OEFeatureAccessTypes.licensing;

    return {
        isConnected: isConnected,
        isLicensing: isLicensing,
        isValid: isLicensing ? false : true,
        edition: isLicensing ? OELicensingEdition.none : OELicensingEdition.master
    };
};